/**
 * Generic script loader. Injects scripts into document.head.
 * Use scripts in ./scripts/ for Leadinfo and GTM.
 */

export interface LoadScriptOptions {
  async?: boolean
  defer?: boolean
  id?: string
  /** Called when the script has loaded and executed. */
  onLoad?: () => void
}

/**
 * Load a script by URL into document.head. Resolves when the script has loaded.
 */
export function loadScript(src: string, options: LoadScriptOptions = {}): Promise<void> {
  const { async = true, defer, id, onLoad } = options

  return new Promise((resolve, reject) => {
    const existing = id ? document.getElementById(id) : null
    if (existing) {
      onLoad?.()
      resolve()
      return
    }

    const script = document.createElement('script')
    script.src = src
    script.async = async
    if (defer) script.defer = true
    if (id) script.id = id
    script.onload = () => {
      onLoad?.()
      resolve()
    }
    script.onerror = () => reject(new Error(`Failed to load script: ${src}`))
    document.head.appendChild(script)
  })
}
